import React from "react";
import { Card, Typography, Box } from "@mui/material";

const DeviceTestErrorPopup = ({ message, onClose }) => (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    //   background: "rgba(0,0,0,.45)",
    backgroundColor: "rgba(0,0,0,0.35)",
backdropFilter: "blur(6px)",
WebkitBackdropFilter: "blur(6px)",
      zIndex: 9999,
    }}
  >
    <Card
      sx={{
        p: 4,
        minWidth: 350,
        textAlign: "center",
        borderRadius: 2,
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        Device Test Failed
      </Typography>

      <Typography sx={{ mb: 3 }}>
        {message}
      </Typography>

      <button
        className="btn"
        onClick={onClose}
      >
        OK
      </button>
    </Card>
  </Box>
);

export default DeviceTestErrorPopup;